import { css } from "styled-components";

export type FlexSharedProps = {
  justifyContent?: string;
  alignItems?: string;
  flexDirection?: string;
  $justifyContent?: string;
  $alignItems?: string;
  $flexDirection?: string;
};

export const FlexShared = css<FlexSharedProps>`
  display: flex;
  justify-content: ${({ justifyContent, $justifyContent }) =>
    $justifyContent || justifyContent || "space-between"};
  align-items: ${({ alignItems, $alignItems }) =>
    $alignItems || alignItems || "center"};
  flex-direction: ${({ flexDirection, $flexDirection }) =>
    $flexDirection || flexDirection || "row"};
`;
